import React, { useEffect, useState } from 'react'
import { TextField } from '@material-ui/core'
import Slider from '@mui/material/Slider'

const maxValue = 500000
const maxTenure = 36
const maxInerest = 60

const EmiCalulator = () => {
  const [loanAmount, setLoanAmount] = useState(1000)
  const [tenureAmount, setTenureAmount] = useState(3)
  const [InterestAmount, setInterestAmount] = useState(10)
  const [errorMassage, setErrorMassage] = useState(false)
  const [errorMassageTenure, setErrorMassageTenure] = useState(false)
  const [errorMassageIntrest, setErrorMassageIntrest] = useState(false)
  const [monthlyEmi, setMonthlyEmi] = useState()
  const [totalInterest, setTotalInterest] = useState()
  const [payableAmount, setPayableAmount] = useState()
  const [effectiveInterestRate, seteffEctiveInterestRate] = useState()

  useEffect(() => {
    calculateEmi()
  }, [loanAmount, tenureAmount, InterestAmount])

  const calculateEmi = () => {
    if (
      !isNaN(loanAmount) &&
      loanAmount !== 0 &&
      !isNaN(tenureAmount) &&
      tenureAmount !== 0 &&
      !isNaN(InterestAmount) &&
      InterestAmount !== 0
    ) {
      const monthlyInterestRatio = (
        parseFloat(InterestAmount) /
        100 /
        12
      ).toFixed(2)
      const top = Math.pow(
        1 + parseFloat(monthlyInterestRatio),
        parseFloat(tenureAmount),
      )
      const bottom = parseFloat(top) - 1
      const sp = parseFloat(top / bottom)
      const emi = parseFloat(loanAmount * monthlyInterestRatio) * sp
      const full = parseFloat(tenureAmount * emi)
      const interest = parseFloat(full - loanAmount)
      const int_pge = parseFloat(interest / full) * 100

      setMonthlyEmi(
        !isNaN(parseFloat(emi.toFixed(2))) ? parseFloat(emi.toFixed(2)) : 0,
      )
      setTotalInterest(
        !isNaN(parseFloat(interest.toFixed(2)))
          ? parseFloat(interest.toFixed(2))
          : 0,
      )
      setPayableAmount(
        !isNaN(parseFloat(full.toFixed(2))) ? parseFloat(full.toFixed(2)) : 0,
      )
      seteffEctiveInterestRate(
        !isNaN(int_pge.toFixed(2)) ? int_pge.toFixed(2) + ' %' : 0 + ' %',
      )
    } else {
      resetValue()
    }
  }

  const resetValue = () => {
    setMonthlyEmi(0)
    setTotalInterest(0)
    setPayableAmount(0)
    seteffEctiveInterestRate(0)
  }

  const onChangeLoanAmount = (loanValue) => {
    if (loanValue >= 1000 && loanValue <= 500000) {
      setLoanAmount(parseInt(loanValue))
      setErrorMassage(false)
    } else {
      if (loanValue >= 0 && loanValue <= 500000)
        setLoanAmount(parseInt(loanValue))
      setErrorMassage(true)
      resetValue()
    }
  }

  const onChangeTenureAmount = (tenure) => {
    if (tenure >= 3 && tenure <= 36) {
      setTenureAmount(parseInt(tenure))
      setErrorMassageTenure(false)
    } else {
      if (tenure >= 0 && (tenure <= 36 || tenure === ''))
        setTenureAmount(parseInt(tenure))
      setErrorMassageTenure(true)
      resetValue()
    }
  }

  const onChangeInterestRateAmount = (interestRate) => {
    if (interestRate >= 10 && interestRate <= 55) {
      setInterestAmount(parseInt(interestRate))
      setErrorMassageIntrest(false)
    } else {
      if (interestRate >= 0 && interestRate <= 55)
        setInterestAmount(parseInt(interestRate))
      setErrorMassageIntrest(true)
      resetValue()
    }
  }

  const loanAmountContainer = () => {
    return (
      <div className="calcCard">
        <div className="calcHead">
          <div className="row">
            <div className="col-md-6 col-sm-7 col-6">
              <h3>Loan Amount</h3>
            </div>
            <div className="col-md-6 col-sm-5 col-6 text-right">
              <div>
                <TextField
                  id="loanAmtText"
                  className="valueBox"
                  value={loanAmount}
                  variant="outlined"
                  inputProps={{
                    maxLength: 6,
                    step: '1',
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                  }}
                  onChange={(e) => onChangeLoanAmount(Number(e.target.value))}
                />
              </div>
              {errorMassage && (
                <span className="tersmValidaiton validationError h5">
                  please select value between 1000 to 500000
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="CustomRangeSlider LoanAmount">
          <Slider
            value={loanAmount}
            onChange={(e) => onChangeLoanAmount(Number(e.target.value))}
            defaultValue={loanAmount}
            max={maxValue}
            min={1000}
            aria-label="Default"
            valueLabelDisplay="off"
          />
        </div>
      </div>
    )
  }

  const loanTenureContainer = () => {
    return (
      <div className="calcCard tenure">
        <div className="calcHead">
          <div className="row">
            <div className="col-md-6 col-sm-7 col-6">
              <h3>Tenure</h3>
            </div>
            <div className="col-md-6 col-sm-5 col-6 text-right">
              <div>
                <TextField
                  id="loanTenureText"
                  className="valueBox"
                  value={tenureAmount}
                  variant="outlined"
                  inputProps={{
                    maxLength: 2,
                    step: '1',
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                  }}
                  onChange={(e) => onChangeTenureAmount(Number(e.target.value))}
                />
              </div>
              {errorMassageTenure && (
                <span className="tersmValidaiton validationError h5">
                  please select value between 3 to 36
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="CustomRangeSlider TenureAmount">
          <Slider
            value={tenureAmount}
            onChange={(e) => onChangeTenureAmount(Number(e.target.value))}
            defaultValue={tenureAmount}
            max={maxTenure}
            min={3}
            aria-label="Default"
            valueLabelDisplay="off"
          />
        </div>
      </div>
    )
  }

  const loanInterestRateContainer = () => {
    return (
      <div className="calcCard">
        <div className="calcHead">
          <div className="row">
            <div className="col-md-6 col-sm-7 col-6">
              <h3>Interest Rate</h3>
            </div>
            <div className="col-md-6 col-sm-5 col-6 text-right">
              <div>
                <TextField
                  id="loanrateOfInterestText"
                  className="valueBox"
                  value={InterestAmount}
                  variant="outlined"
                  inputProps={{
                    maxLength: 2,
                    step: '1',
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                  }}
                  onChange={(e) =>
                    onChangeInterestRateAmount(Number(e.target.value))
                  }
                  maxLength={6}
                />
              </div>
              {errorMassageIntrest && (
                <span className="tersmValidaiton validationError h5">
                  please select value between 10 to 56
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="CustomRangeSlider InterestAmount">
          <Slider
            value={InterestAmount}
            onChange={(e) => onChangeInterestRateAmount(Number(e.target.value))}
            defaultValue={InterestAmount}
            max={maxInerest}
            min={10}
            aria-label="Default"
            valueLabelDisplay="off"
          />
        </div>
      </div>
    )
  }

  const loanResultContainer = () => {
    return (
      <div className="calculationRslt">
        <div className="row">
          <div className="col-md-3">
            <label>Monthly EMI</label>
            <input
              type="text"
              name="Monthly EMI"
              value={monthlyEmi}
              readonly="readonly"
            />
          </div>
          <div className="col-md-3">
            <label>Total Interest</label>
            <input
              type="text"
              name="Monthly EMI"
              value={totalInterest}
              readonly="readonly"
            />
          </div>
          <div className="col-md-3">
            <label>Payable Amount</label>
            <input
              type="text"
              name="Monthly EMI"
              value={payableAmount}
              readonly="readonly"
            />
          </div>
          <div className="col-md-3">
            <label>Effective Interest Rate</label>
            <input
              type="text"
              name="Monthly EMI"
              value={effectiveInterestRate}
              readonly="readonly"
            />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <div className="CalcBox">
        {loanAmountContainer()}
        {loanTenureContainer()}
        {loanInterestRateContainer()}
      </div>
      {loanResultContainer()}
    </div>
  )
}

export default EmiCalulator
